/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Button_DownInputs */

const en_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Button-Down`)
};

const es_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camisa de botones`)
};

const fr_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemise boutonnée`)
};

const de_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemd`)
};

const ja_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボタンダウン/シャツ`)
};

const zh_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正装衬衫`)
};

const ar_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قميص بأزرار`)
};

const id_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemeja`)
};

const it_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camicia`)
};

const ru_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рубашка`)
};

const pt_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camisa de Botão`)
};

const ko_val_button_down = /** @type {(inputs: Val_Button_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`버튼다운/셔츠`)
};

/**
* | output |
* | --- |
* | "Button-Down" |
*
* @param {Val_Button_DownInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_button_down = /** @type {((inputs?: Val_Button_DownInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Button_DownInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_button_down(inputs)
	if (locale === "es") return es_val_button_down(inputs)
	if (locale === "fr") return fr_val_button_down(inputs)
	if (locale === "de") return de_val_button_down(inputs)
	if (locale === "ja") return ja_val_button_down(inputs)
	if (locale === "zh") return zh_val_button_down(inputs)
	if (locale === "ar") return ar_val_button_down(inputs)
	if (locale === "id") return id_val_button_down(inputs)
	if (locale === "it") return it_val_button_down(inputs)
	if (locale === "ru") return ru_val_button_down(inputs)
	if (locale === "pt") return pt_val_button_down(inputs)
	return ko_val_button_down(inputs)
});